import zhCNCommon from '../locales/zh-CN/common.json';
import zhCNLayout from '../locales/zh-CN/layout.json';
import zhCNPages from '../locales/zh-CN/pages.json';
import zhCNComponents from '../locales/zh-CN/components.json';
import zhCNErrors from '../locales/zh-CN/errors.json';
import zhCNForms from '../locales/zh-CN/forms.json';
import zhCNOutput from '../locales/zh-CN/output.json';
import zhCNSettings from '../locales/zh-CN/settings.json';
import zhCNAnnouncements from '../locales/zh-CN/announcements.json';

import enCommon from '../locales/en/common.json';
import enLayout from '../locales/en/layout.json';
import enPages from '../locales/en/pages.json';
import enComponents from '../locales/en/components.json';
import enErrors from '../locales/en/errors.json';
import enForms from '../locales/en/forms.json';
import enOutput from '../locales/en/output.json';
import enSettings from '../locales/en/settings.json';
import enAnnouncements from '../locales/en/announcements.json';

import ruCommon from '../locales/ru/common.json';
import ruLayout from '../locales/ru/layout.json';
import ruPages from '../locales/ru/pages.json';
import ruComponents from '../locales/ru/components.json';
import ruErrors from '../locales/ru/errors.json';
import ruForms from '../locales/ru/forms.json';
import ruOutput from '../locales/ru/output.json';
import ruSettings from '../locales/ru/settings.json';
import ruAnnouncements from '../locales/ru/announcements.json';

import koCommon from '../locales/ko/common.json';
import koLayout from '../locales/ko/layout.json';
import koPages from '../locales/ko/pages.json';
import koComponents from '../locales/ko/components.json';
import koErrors from '../locales/ko/errors.json';
import koForms from '../locales/ko/forms.json';
import koOutput from '../locales/ko/output.json';
import koSettings from '../locales/ko/settings.json';
import koAnnouncements from '../locales/ko/announcements.json';

import jaCommon from '../locales/ja/common.json';
import jaLayout from '../locales/ja/layout.json';
import jaPages from '../locales/ja/pages.json';
import jaComponents from '../locales/ja/components.json';
import jaErrors from '../locales/ja/errors.json';
import jaForms from '../locales/ja/forms.json';
import jaOutput from '../locales/ja/output.json';
import jaSettings from '../locales/ja/settings.json';
import jaAnnouncements from '../locales/ja/announcements.json';

import esCommon from '../locales/es/common.json';
import esLayout from '../locales/es/layout.json';
import esPages from '../locales/es/pages.json';
import esComponents from '../locales/es/components.json';
import esErrors from '../locales/es/errors.json';
import esForms from '../locales/es/forms.json';
import esOutput from '../locales/es/output.json';
import esSettings from '../locales/es/settings.json';
import esAnnouncements from '../locales/es/announcements.json';

import deCommon from '../locales/de/common.json';
import deLayout from '../locales/de/layout.json';
import dePages from '../locales/de/pages.json';
import deComponents from '../locales/de/components.json';
import deErrors from '../locales/de/errors.json';
import deForms from '../locales/de/forms.json';
import deOutput from '../locales/de/output.json';
import deSettings from '../locales/de/settings.json';
import deAnnouncements from '../locales/de/announcements.json';

export const resources = {
  'zh-CN': {
    common: zhCNCommon,
    layout: zhCNLayout,
    pages: zhCNPages,
    components: zhCNComponents,
    errors: zhCNErrors,
    forms: zhCNForms,
    output: zhCNOutput,
    settings: zhCNSettings,
    announcements: zhCNAnnouncements
  },
  en: {
    common: enCommon,
    layout: enLayout,
    pages: enPages,
    components: enComponents,
    errors: enErrors,
    forms: enForms,
    output: enOutput,
    settings: enSettings,
    announcements: enAnnouncements
  },
  ru: {
    common: ruCommon,
    layout: ruLayout,
    pages: ruPages,
    components: ruComponents,
    errors: ruErrors,
    forms: ruForms,
    output: ruOutput,
    settings: ruSettings,
    announcements: ruAnnouncements
  },
  ko: {
    common: koCommon,
    layout: koLayout,
    pages: koPages,
    components: koComponents,
    errors: koErrors,
    forms: koForms,
    output: koOutput,
    settings: koSettings,
    announcements: koAnnouncements
  },
  ja: {
    common: jaCommon,
    layout: jaLayout,
    pages: jaPages,
    components: jaComponents,
    errors: jaErrors,
    forms: jaForms,
    output: jaOutput,
    settings: jaSettings,
    announcements: jaAnnouncements
  },
  es: {
    common: esCommon,
    layout: esLayout,
    pages: esPages,
    components: esComponents,
    errors: esErrors,
    forms: esForms,
    output: esOutput,
    settings: esSettings,
    announcements: esAnnouncements
  },
  de: {
    common: deCommon,
    layout: deLayout,
    pages: dePages,
    components: deComponents,
    errors: deErrors,
    forms: deForms,
    output: deOutput,
    settings: deSettings,
    announcements: deAnnouncements
  }
} as const;

export type AppNamespaces = keyof (typeof resources)['zh-CN'];
export type SupportedLanguage = keyof typeof resources;
export const defaultNS: AppNamespaces = 'common';
export const namespaces: AppNamespaces[] = ['common', 'layout', 'pages', 'components', 'errors', 'forms', 'output', 'settings', 'announcements'];

export type ResourceSchema = (typeof resources)['zh-CN'];
